














































import Vue from 'vue'
import { mapGetters } from 'vuex'
import DownloadAnnotation from '@/components/DownloadAnnotation.vue'
import ContentsLink from '@/components/ContentsLink.vue'

export default Vue.extend({
  name: 'Product',

  components: {
    DownloadAnnotation,
    ContentsLink
  },

  props: {
    code: String
  },

  computed: {
    ...mapGetters(['contents']),
    knums(): string[] {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return this.contents.knum.split('／')
    },
    titles(): string[] {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return this.contents.title.split('／')
    }
  },

  data: () => ({
    //
  }),

  methods: {
    getIcon(file: string): string {
      const def = 'file-document'
      const config = {
        txt: 'file-document',
        docx: 'file-word',
        xlsm: 'file-excel',
        xlsx: 'file-excel',
        pptx: 'file-powerpoint',
        pdf: 'file-pdf-box',
        jpg: 'file-image',
        ipynb: 'language-python',
        py: 'language-python'
      } as { [key: string]: string }
      if (file.match(/\.([^.]+)$/)) {
        const ext = RegExp.$1
        return String(config[ext]) || def
      } else {
        return def
      }
    }
  }
})
